import React, { Component } from 'react';
import i18n from 'i18next';
import { Trans, withTranslation } from 'react-i18next';
import LanguageService from "../services/language-service";

const changeLanguage = (lng) => {
  i18n.changeLanguage(lng);
  LanguageService.changeLanguage(lng).then(res =>{
  });
};
class LanguageSwitch extends Component {
    
    render() {
        return (
            <div className="dropdown w-auto my-5">
                <button className="btn btn-outline-secondary bg-white dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                    <i className="obn obn-globe-1 me-2"></i><Trans i18nKey="language" />
                </button>
                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <li><a className="dropdown-item" onClick={() => changeLanguage('de')}>Deutsch</a></li>
                    <li><a className="dropdown-item" onClick={() => changeLanguage('en')}>English</a></li>
                    <li><a className="dropdown-item" onClick={() => changeLanguage('fr')}>Français</a></li>
                    <li><a className="dropdown-item" onClick={() => changeLanguage('it')}>Italiano</a></li>
                    <li><a className="dropdown-item" onClick={() => changeLanguage('nl')}>Nederlands</a></li>
                    <li><a className="dropdown-item" onClick={() => changeLanguage('pt')}>Portuguese</a></li>
                </ul>
            </div>
        );
    }
}

export default withTranslation()(LanguageSwitch);
